import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";
import { Users, Package as PackageIcon, ArrowRight } from "lucide-react";
import SafeImage from "@/components/SafeImage";

export default function PackagesPage() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/packages").then((r) => {
      setPackages(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="bg-arre-black min-h-screen" data-testid="packages-page">
      {/* Hero */}
      <section className="relative pt-16 pb-20 border-b border-arre-border overflow-hidden grain">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-25"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=1920&q=85')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-arre-black/70 to-arre-black" />
        <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12">
          <div className="text-xs tracking-[0.35em] uppercase text-arre-red mb-3">⟡ Los favoritos del compare</div>
          <h1 className="font-display text-6xl md:text-9xl tracking-wider uppercase text-white leading-[0.85]">
            Paquetes<br />
            <span className="text-arre-red italic font-serif-display normal-case tracking-tight">para no fallar</span>
          </h1>
          <p className="font-serif-display italic text-xl md:text-2xl text-white/80 mt-6 max-w-2xl">
            Combos armados con cariño: cortes, acompañamientos y todo lo que necesitas para una parrilla memorable.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-16">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {Array(6).fill(0).map((_, i) => (
                <div key={i} className="aspect-[4/5] bg-arre-surface animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {packages.map((p) => (
                <Link
                  key={p.slug}
                  to={`/paquete/${p.slug}`}
                  className="group relative overflow-hidden bg-arre-surface border border-arre-border hover:border-arre-red transition-colors hover-zoom"
                  data-testid={`package-${p.slug}`}
                >
                  <div className="aspect-[4/5] overflow-hidden">
                    <SafeImage src={p.image} alt={p.name} fallbackLabel={p.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-arre-black via-arre-black/50 to-transparent" />
                  {p.badge && (
                    <span className="absolute top-4 left-4 bg-arre-red text-white text-[10px] tracking-[0.3em] uppercase font-bold px-3 py-1.5">
                      {p.badge}
                    </span>
                  )}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="text-[10px] tracking-[0.3em] uppercase text-arre-red mb-2">{p.tagline}</div>
                    <h3 className="font-display text-4xl tracking-wider uppercase text-white leading-none">{p.name}</h3>
                    <div className="flex items-center gap-4 mt-3 text-white/70 text-xs">
                      <span className="flex items-center gap-1.5">
                        <Users className="w-3.5 h-3.5" />
                        {p.serves}
                      </span>
                      <span className="flex items-center gap-1.5">
                        <PackageIcon className="w-3.5 h-3.5" />
                        {p.items.length} items
                      </span>
                    </div>
                    <div className="flex items-center justify-between mt-5">
                      <span className="font-display text-3xl text-white">{fmtMXN(p.price)}</span>
                      <span className="text-arre-red font-display text-sm tracking-widest uppercase inline-flex items-center gap-1">
                        Ver <ArrowRight className="w-4 h-4" />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
